import { apiClient, routes, type ApiClientResponse } from 'common/services';
import { type VideoContentObjectDataObject } from 'models/service/content-object';

export const getVideoDetail = async (videoId: string) =>
  apiClient.get<VideoContentObjectDataObject, ApiClientResponse<VideoContentObjectDataObject>>(
    routes.videos.get(videoId),
  );
